export const PROJECT_TRACKS = {
  PRODUCT: 'product',
  RESEARCH: 'research',
  PRODUCT_RESEARCH: 'product_research'
};

export const PROJECT_STATUS = {
  NOT_STARTED: 'not_started',
  IN_PROGRESS: 'in_progress',
  ON_HOLD: 'on_hold',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

export const MILESTONE_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  APPROVED: 'approved'
};

export const ASSIGNMENT_STATUS = {
  PENDING: 'pending',
  SUBMITTED: 'submitted',
  REVIEWED: 'reviewed'
};

export const BOM_STATUS = {
  PENDING: 'pending',
  ORDERED: 'ordered',
  RECEIVED: 'received'
};

export const COMPETITION_STATUS = {
  NOT_SUBMITTED: 'not_submitted',
  SUBMITTED: 'submitted',
  WON: 'won',
  REJECTED: 'rejected'
};

export const USER_ROLES = {
  ADMIN: 'admin',
  MENTOR: 'mentor'
};

export const STATUS_COLORS = {
  // Project statuses
  not_started: '#999999',        // Gray
  in_progress: '#2196F3',        // Blue
  on_hold: '#FF9800',            // Orange
  completed: '#388E3C',          // Dark Green
  cancelled: '#F44336',          // Red
  pending: '#999999',
  approved: '#4CAF50',
  
  // Assignment statuses
  assigned: '#2196F3',           // Blue
  submitted: '#4CAF50',          // Green
  submitted_late: '#FF9800',     // Orange
  overdue: '#F44336',            // Red
  returned: '#9C27B0',           // Purple
  half_done: '#FF9800',          // Orange — partially done
  not_done: '#F44336',           // Red — never done
  
  // Competition workflow statuses
  changes_required: '#FF9800',   // Orange
  ready: '#4CAF50',              // Green

  // Other statuses
  reviewed: '#4CAF50',
  ordered: '#FFD700',
  received: '#4CAF50',
  won: '#4CAF50',
  rejected: '#FF6B6B'
};

export const TRACK_TEMPLATES = {
  product: {
    M1: ['Brainstorm + Introduction to mentor and research area'],
    M2: ['Scope Finalisation'],
    M3: ['Learning', 'Workflow (BOM, connections, software architecture, content architecture)'],
    M4: ['Building', 'Testing (might need to re-build)', 'Deployment', 'Data collection & Data analysis (OPTIONAL)'],
    M5: ['Competition submission']
  },
  research: {
    M1: ['Brainstorm + Introduction to mentor and research area'],
    M2: ['Lit review', 'Introduction'],
    M3: ['Methodology (hypothesis formulation)'],
    M4: ['Data collection', 'Data analysis', 'Results'],
    M5: ['Discussion & Abstract'],
    M6: ['Final Manuscript'],
    M7: ['Journal submission'],
    M8: ['Competition submission']
  },
  product_research: {
    M1: ['Brainstorm + Introduction to mentor and research area'],
    M2: ['Lit review', 'Introduction'],
    M3: ['Systems design (Optional)', 'Methodology'],
    M4: ['Data collection', 'Data analysis', 'Results'],
    M5: ['Discussion & Abstract'],
    M6: ['Final Manuscript'],
    M7: ['Journal submission'],
    M8: ['Competition submission']
  }
};